<template>
  <div class="wrapper">
    <div class="contentModule">
      <div class="theme">
        <div>
          <div class="insuranceTheme">国内贸易信用险 - 订单详情</div>
          <div class="insuranceDescription"></div>
        </div>
      </div>
      <div class="section">
        <div class="customerIcon">
          <span class="icon"></span>
        </div>
        <div class="processProcedure" style="width: 15rem;">
          <div class="unit">
            <span>01</span>
            <span>投保人信息</span>
          </div>
        </div>
        <ul class="insureList">
          <li><span>订单号：</span><span>{{items.orderId}}</span></li>
          <li><span>投保人名称：</span><span>{{items.policyHolder.companyName}}</span></li>
          <li><span>注册地址：</span><span>{{items.policyHolder.companyAddress}}</span></li>
          <li><span>通讯地址：</span><span>{{items.policyHolder.address}}</span></li>
          <li><span>联系人：</span><span>{{items.policyHolder.name}}</span></li>
          <li><span>手机号：</span><span>{{items.policyHolder.mobile}}</span></li>
          <li><span>电子邮箱：</span><span>{{items.policyHolder.email}}</span></li>
          <li><span>是否为被保险人：</span><span>{{items.orderExtendAddress.isInsured}}</span></li>
          <li><span>是否存在共同被保险人：</span><span>{{items.orderExtendAddress.isCommonInsured}}</span></li>
          <li><span>共同被保险人保险手续办理方式：</span><span>{{items.orderExtendAddress.commonInsuredProcessType}}</span></li>
        </ul>

        <div class="processProcedure" style="width: 20rem;">
          <div class="unit">
            <span>02</span>
            <span>被保险人基本信息</span>
          </div>
        </div>
        <ul>
          <li><span>公司名称：</span><span>{{items.insuredUserInfo[0].name}}</span></li>
          <li v-show="this.$$.isValidObj(items.orderExtendAddress.insuredEnglishName)"><span>公司英文名称：</span><span>{{items.orderExtendAddress.insuredEnglishName}}</span></li>
          <li><span>注册资本：</span><span>{{items.orderExtendAddress.registeredAmout}}</span></li>
          <li><span>统一社会信用代码：</span><span>{{items.insuredUserInfo[0].cardNum}}</span></li>
          <li><span>成立时间：</span><span>{{items.insuredUserInfo[0].birthday}}</span></li>
          <li><span>法定代表人：</span><span>{{items.orderExtendAddress.legalRepresentative}}</span></li>
          <li><span>注册地址：</span><span>{{items.orderExtendAddress.registryAddress}}</span></li>
          <li><span>通讯地址：</span><span>{{items.orderExtendAddress.contactAddress}}</span></li>
          <li><span>邮政编码：</span><span>{{items.policyHolder.postcode}}</span></li>
          <li><span>公司性质：</span><span>{{items.orderExtendAddress.companyNature}}</span></li>
          <li><span>经营性质：</span><span>{{items.orderExtendAddress.businessNature}}</span></li>
          <li><span>经营范围：</span><span>{{items.orderExtendAddress.businessScope}}</span></li>
          <li><span>所属行业：</span><span>{{items.orderExtendAddress.industryValue}}</span></li>
          <li><span>是否上市：</span><span>{{items.orderExtendAddress.isOnMarket}}</span></li>
          <li v-show="items.orderExtendAddress.isOnMarket == '是'"><span>上市地点：</span><span>{{items.orderExtendAddress.onMarketPlace}}</span></li>
          <li v-show="items.orderExtendAddress.isOnMarket == '是'"><span>上市年份：</span><span>{{items.orderExtendAddress.onMarketYear}}</span></li>
        </ul>

        <div class="processProcedure"style="width: 13rem;">
          <div class="unit">
            <span>03</span>
            <span>投保意向</span>
          </div>
        </div>
        <ul>
          <li><span>拟投保业务：</span><span>{{items.orderExtendAddress.businessInsured}}</span></li>
          <li><span>拟投保业务类型：</span><span>{{items.orderExtendAddress.businessType}}</span></li>
          <li><span>是否全部业务投保：</span><span>{{items.orderExtendAddress.isAllBusinessInsured}}</span></li>
          <li><span>拟投保业务开始年份：</span><span>{{items.orderExtendAddress.businessInsuredYear}}</span></li>
          <li><span>预计未来12个月投保业务规模：</span><span>{{items.orderExtendAddress.businessScale}}</span></li>
          <li><span>目前或过去是否已有国内贸易信用保险保单或保理安排：</span><span>{{items.orderExtendAddress.isInsuredPolicy}}</span></li>
          <li v-show="items.orderExtendAddress.isInsuredPolicy == '是'"><span>保险/保理公司名称：</span><span>{{items.orderExtendAddress.lastInsuredComName}}</span></li>
          <li v-show="items.orderExtendAddress.isInsuredPolicy == '是'"><span>最近保险合同到期日：</span><span>{{items.orderExtendAddress.lastInsuredExpireDate}}</span></li>
        </ul>

        <div class="processProcedure"style="width: 22rem;">
          <div class="unit">
            <span>04</span>
            <span>被保险人联系人信息</span>
          </div>
        </div>
        <ul>
          <li><span>联系人：</span><span>{{items.orderExtendAddress.linkerName}}</span></li>
          <li><span>联系人手机号：</span><span>{{items.orderExtendAddress.linkerPhone}}</span></li>
          <li><span>联系人电子邮箱：</span><span>{{items.orderExtendAddress.linkerMail}}</span></li>
          <li v-show="this.$$.isValidObj(items.orderExtendAddress.linkerJob)"><span>联系人职务：</span><span>{{items.orderExtendAddress.linkerJob}}</span></li>
          <li v-show="this.$$.isValidObj(items.orderExtendAddress.linkerFax)"><span>联系人传真：</span><span>{{items.orderExtendAddress.linkerFax}}</span></li>
          <li v-show="this.$$.isValidObj(items.orderExtendAddress.agentName)"><span>代理人：</span><span>{{items.orderExtendAddress.agentName}}</span></li>
          <li v-show="this.$$.isValidObj(items.orderExtendAddress.agentPhone)"><span>代理人手机号：</span><span>{{items.orderExtendAddress.agentPhone}}</span></li>
          <li v-show="this.$$.isValidObj(items.orderExtendAddress.agentMail)"><span>代理人电子邮箱：</span><span>{{items.orderExtendAddress.agentMail}}</span></li>
          <li v-show="this.$$.isValidObj(items.orderExtendAddress.agentJob)"><span>代理人职务：</span><span>{{items.orderExtendAddress.agentJob}}</span></li>
          <li v-show="this.$$.isValidObj(items.orderExtendAddress.agentFax)"><span>代理人传真：</span><span>{{items.orderExtendAddress.agentFax}}</span></li>
        </ul>

        <div class="processProcedure"style="width: 15rem;">
          <div class="unit">
            <span>05</span>
            <span>上传证件</span>
          </div>
        </div>
        <ul class="uploadInfo">
          <!--<li>
            <span>身份证人脸面：</span>
            <span><img class="" :src="items.orderExtendAddress.idCardFront" alt="身份证人脸面"/></span>
          </li>
          <li>
            <span>身份证国徽面：</span>
            <span><img class="" :src="items.orderExtendAddress.idCardBack" alt="身份证国徽面"/></span>
          </li>
          <li>
            <span>营业执照：</span>
            <span><img class="" :src="items.orderExtendAddress.busLicense" alt="营业执照"/></span>
          </li>-->
          <li>
            <span>身份证人脸面：</span>
            <span><a :href="items.orderExtendAddress.idCardFront" target="_blank" style="color: #ff7052">{{items.orderExtendAddress.idCardFront}}</a></span>
          </li>
          <li>
            <span>身份证国徽面：</span>
            <span><a :href="items.orderExtendAddress.idCardBack" target="_blank" style="color: #ff7052">{{items.orderExtendAddress.idCardBack}}</a></span>
          </li>
          <li>
            <span>营业执照：</span>
            <span><a :href="items.orderExtendAddress.busLicense" target="_blank" style="color: #ff7052">{{items.orderExtendAddress.busLicense}}</a></span>
          </li>
          <li>
            <span>其他附件：</span>
            <span><a :href="items.orderExtendAddress.otherFile" target="_blank" style="color: #ff7052">{{items.orderExtendAddress.otherFile}}</a></span>
          </li>
        </ul>
        <div class="submitOrder" v-show="'0,1,8'.includes(this.items.orderStatus)">
          <el-button @click="orderPaymentBefore" class="header-button-order-add">确认订单</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "domesticTradeCredit_orderDetail",
      data() {
        return {
          items:{
            policyHolder: {},
            insuredUserInfo: [],
            orderExtendAddress: {},
          },
          orderToken: "",                   // 订单Token
          beShareToken: "",
          eventLogToken: "",                // 事件日志Token
        };
      },
      methods: {
        // 加载订单详情
        loadOrderDetail(){
          let that = this;
          const { orderToken, beShareToken } = that;

          that.$$.request({
            url: that.UrlConfig.insuranceInfo_loadOrderDetail,
            pars: {
              orderToken,
              beShareToken,
            },
            loading: true,
            sfn: function (data) {
              that.$$.closeLoading();
              if (data.success) {
                that.items = {...data.datas};

                // 产品屏幕录制
                if ('0,1'.includes(that.items.orderStatus)) {
                  that.recording(that.items.orderId);
                }
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        // 确认订单 - 订单支付前作数据校验
        orderPaymentBefore(){
          let that = this;
          const { orderToken, beShareToken } = that;

          that.$$.request({
            url: that.UrlConfig.insuranceInfo_orderPaymentBefore,
            pars: {
              orderToken,
              beShareToken,
            },
            loading: true,
            sfn: function (data) {
              that.$$.closeLoading();
              if (data.success) {
                that.insureOrder();
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        // 确认订单 - 去支付
        insureOrder(){
          let that = this;
          const { orderToken } = that;

          that.$$.request({
            url: that.UrlConfig.management_mobileInsuranceInfo_bindSellBillAtCostHandler,
            pars: {
              orderToken,
            },
            loading: true,
            sfn: function (data) {
              that.$$.closeLoading();
              if (data.success) {
                that.$message.success("提交成功");
                const { payUrl } = data.datas;
                setTimeout(function(){
                  if (payUrl){
                    location.href = payUrl;
                  }else {
                    location.reload();
                  }
                }, 1000);
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        // 产品屏幕录制
        recording(id){
          let that = this;
          let eventLogToken = decodeURIComponent(encodeURIComponent(that.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
          if (that.$$.isValidObj(eventLogToken)) {
            that.screenRecBase.startLoad(id);
            that.eventLogToken = eventLogToken;
          }
        },

      },
      mounted() {
        let that = this;
        const {orderToken, beShareToken, eventLogToken} = that.$route.query;
        that.orderToken = orderToken;
        let shareToken = decodeURIComponent(encodeURIComponent(beShareToken).replace(new RegExp("%20","gm"),"%2B"));
        that.beShareToken = shareToken;
        that.eventLogToken = eventLogToken;

        that.loadOrderDetail();

      },
    }
</script>

<style scoped>
  @import "../../../../static/css/dutyInsurance/fillInfo.css";
  .wrapper{
    padding: 20px 0;
  }

  .section{
    position: relative;
    min-width: 1000px;
    margin: 0 auto;
    padding: 2rem 5%;
    background: #FFFFFF;
    box-shadow: 0 0 1rem 0 rgba(203, 203, 203, 0.2);
  }
  .must{
    color: #FF7052;
    display: inline-block;
  }

  .customerIcon{
    width: 40px;
    height: 30px;
    background: #5677fc;
    display: inline-block;
    position: absolute;
    right: 0;
    border-radius: 20px 0 0 20px;
    top: -35px;
    z-index: 2;
  }
  .customerIcon .icon{
    background: url('../../../../static/images/public/autoInsurance/customerIcon.png') no-repeat;
    width: 21px;
    height: 18px;
    display: inline-block;
    background-size: contain;
    margin-top: 6px;
    margin-left: 12px;
  }

  ul{
    padding: 3rem 0;
    font-size: 15px;
  }

  li{
    position: relative;
    width: 100%;
    padding: 5px 0;
    background-color: #fff;
    display: inline-block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-user-select: none;
    -moz-user-select: none;
  }
  li>span:first-child{
    width: 240px;
    color: #000;
    letter-spacing: 1px;
    display: inline-block;
    text-align: right;
  }

  li>span:last-child{
    color: #ff7052;
    display: inline-block;
    width: 50%;
  }

  .uploadInfo>li{
    margin-bottom: 20px;
  }

  .submitOrder{
    width: 100%;
    margin: 20px auto;
    text-align: center;
  }

  .header-button-order-add {
    width: 20rem;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-bottom: 25px;
  }

  .header-button-order-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/domesticTradeCredit/orderDetail.vue